import { LFlex, LSubTitle, LTitle } from "@components";
import { faCircleLeft, faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";

export const ContactFacilitator = (): JSX.Element => {
    return (
        <>
            <LFlex justifyCenter alignCenter className="p-6">
                <LFlex className="is-justify-content-space-between" row>
                    <LFlex alignCenter justifyCenter>
                        <LTitle color="has-text-dark-blue">Contact Assessment Facilitator</LTitle>
                        <LSubTitle size="5" color="has-text-dark-blue" className="mt-3">
                            If you’re having trouble setting up your device for this assessment, get in touch by phone
                            or email:
                        </LSubTitle>
                    </LFlex>
                </LFlex>

                <LFlex alignCenter justifyCenter className="mt-6 pt-6">
                    <p className="is-size-5 has-text-weight-bold has-text-grey">Phone Number</p>
                    <LFlex row alignCenter className="my-4">
                        <FontAwesomeIcon icon={faPhone} size="xl" color="#113558" />
                        <p className="mx-4 is-size-4 has-text-weight-bold has-text-dark-blue">415-123-4567</p>
                    </LFlex>
                    <p className="has-text-dark-blue">Monday - Friday</p>
                    <p className="has-text-dark-blue">8 AM - 6 PM PST</p>

                    <div className="divider minw-85 my-6" />

                    <p className="is-size-5 has-text-weight-bold has-text-grey">Email Address</p>
                    <LFlex row alignCenter className="my-2">
                        <FontAwesomeIcon icon={faEnvelope} size="xl" color="#113558" />
                        <p className="mx-4 is-size-4 has-text-weight-bold has-text-dark-blue">info@orgname.com</p>
                    </LFlex>
                </LFlex>

                <div style={{ position: "absolute", right: "5%", bottom: "5%" }}>
                    <NavLink to="/admin/assessments/assessmentsUpcoming">
                        <FontAwesomeIcon icon={faCircleLeft} size={"xl"} />
                        <span className="subtitle px-2 has-text-primary-blue">Exit assessment</span>
                    </NavLink>
                </div>
            </LFlex>
        </>
    );
};
